import { RefreshGroup } from '@pubstack/common/src/refresh'

export const useValidateRefreshGroup = (refreshGroup?: RefreshGroup) => {
  const isNameValid = !!refreshGroup?.name
  const isAdunitsValid = !!refreshGroup?.adUnits.length
  const isSitesValid = !!refreshGroup?.tagIds.length
  const isDevicesValid = !!refreshGroup?.devices.length

  const isKeyValuesValid = !refreshGroup
    ? false
    : refreshGroup.keyValueTargetings
      ? refreshGroup.keyValueTargetings.every((kvt) => (kvt.key && kvt.values.length) || (!kvt.key && !kvt.values.length))
      : true

  const isRulesValid = !refreshGroup
    ? false
    : refreshGroup.specificRules
      ? refreshGroup.specificRules.every((rule) => (rule.bidderName && rule.timer > 0) || (!rule.bidderName && !rule.timer)) && refreshGroup.timer > 0
      : refreshGroup.timer > 0

  const isCappingValid = !refreshGroup ? false : refreshGroup.capping ? refreshGroup.capping > 0 : refreshGroup.capping?.toString() !== ''

  const isCustomSettingsValid = !refreshGroup
    ? false
    : refreshGroup.populationSplit
      ? refreshGroup.populationSplit > 0
      : !refreshGroup.blockerEnabled && refreshGroup.populationSplit?.toString() !== ''

  return {
    name: isNameValid,
    sites: isSitesValid,
    adUnits: isAdunitsValid,
    devices: isDevicesValid,
    keyValueTargetings: isKeyValuesValid,
    rules: isRulesValid,
    capping: isCappingValid,
    customSettings: isCustomSettingsValid,
  }
}
